import { render } from "./MetricDashboardTotals.vue?vue&type=template&id=4255e788&ts=true"
import script from "./MetricDashboardTotals.vue?vue&type=script&lang=ts"
export * from "./MetricDashboardTotals.vue?vue&type=script&lang=ts"

import "./MetricDashboardTotals.vue?vue&type=style&index=0&id=4255e788&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__